<template>
  <div>
    <img src="../assets/images/carousel2.jpg"
         style="width:100%">

  </div>

  <div class="nav_content"
       style="padding-bottom:10px; height:50px">
    <span class="title1"> All Models</span>
    <span style=" margin-left:80px"
          class="title"> X Series</span>
    <span style="margin-left:80px"
          class="title"> Y Series</span>
    <span style="margin-left:80px"
          class="title"> S Series</span>

  </div>
  <el-divider style="margin-top:-12px; z-index:-1"></el-divider>

  <div class="nav_content">
    <span class="content">屏幕尺寸</span>
    <span style="margin-left:105px"
          class="content"> 4.0"-4.9"

    </span>
    <span style="margin-left:105px"
          class="content"> 5.0"-5.4"</span>
    <span style="margin-left:105px"
          class="content"> 5.5"-5.9"</span>
    <span style="margin-left:105px"
          class="content"> >=6.0"</span>

  </div>

  <div class="nav_content">
    <span style=""
          class="content"> 颜色</span>
    <span style="margin-left:155px"
          class="content"> 优雅黑</span>
    <span style="margin-left:105px"
          class="content"> 烟雨青蓝</span>
    <span style="margin-left:105px"
          class="content"> 金色阳光</span>

  </div>

  <div class="shop">
    <div class="show"
         style="margin-left:20px">
      <div style="min-width:450px;">
        <img v-if="color == 'black'"
             src="../assets/images/black2.jpg"
             style="cursor:pointer;width:200px"
             @click="goPage('productDetails/1')">
        <img v-if="color == 'pink'"
             src="../assets/images/pink1.png"
             style="cursor:pointer"
             @click="goPage('productDetails')">
        <img v-if="color == 'green'"
             src="../assets/images/green1.png"
             style="cursor:pointer;width:200px"
             @click="goPage('productDetails/1')">
        <img src="../assets/images/black1.png"
             style="cursor:pointer; margin-left:-130px;z-index:2"
             @click="goPage('productDetails/1')">
        <div style="margin-bottom:20px; display:flex; justify-content:center">
          <div style="display:flex; justify-content:space-around; width:250px">
            <img src="../assets/images/pinkc.png"
                 style="height:30px;width:30px;margin-left:30px"
                 @click="color = 'pink'">

            <img src="../assets/images/blackc.png"
                 style="height:30px;width:30px"
                 @click="color = 'black'">
            <img src="../assets/images/greenc.png"
                 style="height:30px;width:30px;margin-right:30px"
                 @click="color = 'green'">
          </div>

        </div>

        <span class="content">S7 Pro 5G</span>
      </div>

    </div>

  </div>

</template>
<script>
export default {
  methods: {
    goPage (path) {
      this.$router.push({ name: path })
      window.scrollTo(0, 0)
    }
  },

  data () {
    return {
      color: 'black'

    }
  }
}



</script>

<style scoped>
.nav_content {
  display: flex;
  width: 80%;
  margin-left: 150px;
  margin-top: 50px;
  padding-bottom: 10px;
}

.content {
  font-size: 24px;
  font-style: Roboto-bold;
  white-space: nowrap;
}

.title {
  font-size: 28px;
  font-style: Roboto-bold;
  font-weight: bold;
  flex-shrink: 0;
  cursor: pointer;
}

.title1 {
  font-size: 28px;
  font-style: Roboto-bold;
  font-weight: bold;
  flex-shrink: 0;
}

.title:hover {
  font-size: 28px;
  font-style: Roboto-bold;
  font-weight: bold;
  flex-shrink: 0;
  border-bottom: 3px solid red;
  cursor: pointer;
}

.sold_out {
  width: 100px;
  height: 33px;
  line-height: 20px;
  border-radius: 20px 20px 20px 20px;
  color: rgba(83, 83, 83, 79);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(83, 83, 83, 79);
  background-color: transparent;
}

.show {
  display: flex;
  margin-top: 50px;
  justify-content: flex-start;
}

.shop {
  margin-top: 100px;
  margin-left: 0;
  justify-content: center;
}

img {
  width: 200px;
}
</style>
